export default "__VITE_ASSET__BZUIi8oD__"